module.exports = __webpack_public_path__ + "img/gfa-gross-floor-area.bb686891.svg";